import {
  usePortcallApiCalls,
  type CreatePortcallPayload
} from './usePortcallApiCalls'

/**
 * The create-portcall mutation, decoupled from the provider context so any host
 * can submit a new port call — the classic provider modal and the global
 * modal-stack step-flow (which mounts outside the provider) both reach it
 * through this composable rather than through `useCreatePortcall()`.
 */
export function useCreatePortcallCommands() {
  const { createPortcallRequest } = usePortcallApiCalls()

  async function createPortcall(payload: CreatePortcallPayload) {
    return await createPortcallRequest(payload)
  }

  return { createPortcall }
}
